<template>
  <base-view-table
    title="Meus webhooks"
    :pagination="pagination"
    :loading="loading"
    :table="table"
    @search="list()"
  >
    <template #filters>
      <b-row align-v="center">
        <b-col cols="4">
          <b-input
            placeholder="Nome do webhook"
            v-model="fields.name"
            type="text"
            @input="searchTimeOut"
          ></b-input>
        </b-col>
        <b-col>
          <!-- <b-checkbox v-model="fields.active" @change="searchTimeOut">
            Ativos
          </b-checkbox> -->
        </b-col>
      </b-row>
    </template>
    <template #table-header-left>
      <b-button
        pill
        variant="primary"
        @click="$router.push({ name: 'lojista-app-webhooks-integracao' })"
      >
        Habilitar nova integração
      </b-button>
    </template>
    <template #table>
      <b-table
        striped
        hover
        show-empty
        empty-text="Sem registros encontrados"
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template template #cell(webhook.name)="{ item }">
          <span :id="`webhook-name-${item.id}`">
            {{ item.webhook.name }}
            <i class="fas fa-info-circle ml-2 c-blue fs-12"></i>
          </span>
          <b-tooltip :target="`webhook-name-${item.id}`" placement="top">
            {{ item.webhook.description }}
          </b-tooltip>
        </template>
        <template #cell(active)="{ item }">
          <span>{{ item.active ? 'Sim' : 'Não' }}</span>
        </template>
        <template #cell(actions)="{ item }">
          <div class="d-flex align-items-center">
            <div id="check-active-webhook">
              <b-form-checkbox
                v-model="item.active"
                switch
                @change="toggleActive(item)"
              >
                {{ item.active ? 'Desabilitar' : 'Habilitar' }}
              </b-form-checkbox>
              <b-tooltip target="check-active-webhook" placement="top">
                Ao desabilitar um webhook, será interrompido seu funcionamento
              </b-tooltip>
            </div>
            <b-button
              size="sm"
              class="ml-4"
              variant="primary"
              title="Editar"
              @click="
                $router.push({
                  name: 'lojista-app-webhooks-integracao',
                  params: { id: item.id },
                })
              "
            >
              <i class="fas fa-edit"></i>
            </b-button>
          </div>
        </template>
      </b-table>
    </template>
  </base-view-table>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import makeToast from 'Mixins/makeToast';

import BaseViewTable from '@/components/View/BaseViewTable.vue';

export default {
  name: 'ListWebhooks',
  mixins: [makeToast],
  data() {
    return {
      loading: false,
      fields: {
        name: '',
        active: true,
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'webhook.name',
            label: 'Webhook',
            sortable: true,
          },
          {
            key: 'url',
            label: 'URL',
          },
          {
            key: 'active',
            label: 'Ativo',
          },
          {
            key: 'updatedAt',
            label: 'Atualizado em',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
            thStyle: 'width: 80px',
          },
        ],
        records: [],
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 0,
      },
      shopkeepers: [],
      timer: null,
    };
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.$emit('search', { pagination: this.pagination || {} });
    },
  },
  mounted() {
    this.list();
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getWebhookEnabled',
      'toggleActiveWebhookEnabled',
    ]),
    ...mapActions('webhook', ['getWebhooksShopkeeperApp']),
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.list();
      }, 800);
    },
    list() {
      this.loading = true;

      const { active, name } = this.fields;

      this.getWebhookEnabled({
        currentPage: this.pagination.currentPage,
        name,
        active,
        construpUserId: this.dadosUsuario.id,
      })
        .then((response) => {
          const { perPage, total, data } = response.data.data || {};

          this.pagination.itemsPerPage = perPage || 50;
          this.pagination.total = total || 0;

          this.$set(this.table, 'records', data || []);
        })
        .catch((error) => {
          this.makeToast('Erro', error.response.data.message, 'danger');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleActive({ id }) {
      this.loading = true;

      this.toggleActiveWebhookEnabled({
        id,
        construpUserId: this.dadosUsuario.id,
      })
        .then(() => {
          this.list();
        })
        .catch((error) => {
          this.makeToast('Erro', error.response.data.message, 'danger');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    BaseViewTable,
  },
};
</script>

<style scoped>
.limit-chars {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 99%;
}
</style>